import React from 'react'

const TubeIocn = () => {
  return (
    <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={21}
    viewBox="0 0 20 21"
    fill="none"
    >
    <path
        d="M8.33366 12.619L12.6587 10.119L8.33366 7.61898V12.619ZM17.967 6.09398C18.0753 6.48564 18.1503 7.01064 18.2003 7.67731C18.2587 8.34398 18.2837 8.91898 18.2837 9.41898L18.3337 10.119C18.3337 11.944 18.2003 13.2856 17.967 14.144C17.7587 14.894 17.2753 15.3773 16.5253 15.5856C16.1337 15.694 15.417 15.769 14.317 15.819C13.2337 15.8773 12.242 15.9023 11.3253 15.9023L10.0003 15.9523C6.50866 15.9523 4.33366 15.819 3.47533 15.5856C2.72533 15.3773 2.24199 14.894 2.03366 14.144C1.92533 13.7523 1.85033 13.2273 1.80033 12.5606C1.74199 11.894 1.71699 11.319 1.71699 10.819L1.66699 10.119C1.66699 8.29398 1.80033 6.95231 2.03366 6.09398C2.24199 5.34398 2.72533 4.86064 3.47533 4.65231C3.86699 4.54398 4.58366 4.46898 5.68366 4.41898C6.76699 4.36064 7.75866 4.33564 8.67533 4.33564L10.0003 4.28564C13.492 4.28564 15.667 4.41898 16.5253 4.65231C17.2753 4.86064 17.7587 5.34398 17.967 6.09398Z"
        fill="#F8FAFB"
    />
    </svg>

  )
}

export default TubeIocn